import { render, staticRenderFns } from "./AddPaymentMethod.vue?vue&type=template&id=e5c0d268&"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports